import { DonutCard, IGNIS_RED } from "@120wateraudit/waterworks";
import React, { CSSProperties } from "react";
import { Popup } from "semantic-ui-react";
import styled from "styled-components";

import { formatPercent } from "src/utils/format";

const calculateWidth = (x: number, total: number): string => {
  const ratio = x / total;
  if (ratio > 0 && ratio < 0.01) {
    return "1%";
  }

  return formatPercent(ratio);
};

interface Props {
  galvanized: number;
  lead: number;
  nonLead: number;
  style?: CSSProperties;
  unknown: number;
}

const MaterialsDonutCard = ({
  galvanized,
  lead,
  nonLead,
  style,
  unknown,
}: Props): null | JSX.Element => {
  const total = galvanized + lead + nonLead + unknown;
  const leadPercent = calculateWidth(lead, total);
  const galvanizedPercent = calculateWidth(galvanized, total);
  const nonLeadPercent = calculateWidth(nonLead, total);
  const unknownPercent = calculateWidth(unknown, total);

  return (
    <DonutCard
      style={{ height: "100%", ...style }}
      title="Material Classification Breakdown"
      chartData={[
        {
          label: "Lead",
          color: IGNIS_RED,
          metric: { currentValue: parseInt(leadPercent) },
        },
        {
          label: "GRR",
          color: "#FFC720",
          metric: { currentValue: parseInt(galvanizedPercent) },
        },
        {
          label: "Non-Lead",
          color: "#00B5E2",
          metric: { currentValue: parseInt(nonLeadPercent) },
        },
        {
          label: "Unknown",
          color: "#0033A0",
          metric: { currentValue: parseInt(unknownPercent) },
        },
      ]}
      metricName="Total Service Lines"
    />
  );
};

export const StyledPopup = styled(Popup)`
  &&& {
    background-color: #192a3e;
    border-radius: 5px;

    :before {
      background-color: #192a3e;
    }
  }
`;
export default MaterialsDonutCard;
